export const TechnicalErrorDetails = {
  title: 'There seems to be a problem!',
  message: 'We are currently experiencing technical difficulties.',
  topButtonText: 'Refresh page',
  bottomButtonText: 'Back to home page',
  showRefreshButton: true
};

export const Cities = [
  {
    name: 'My Current City'
  },
  {
    name: 'Cape Town',
    latitude: -33.9258,
    longitude: 18.4232,
    code: 3369157
  },
  {
    name: 'Durban',
    latitude: -29.8579,
    longitude: 31.0292,
    code: 1007311
  },
  {
    name: 'Johannesburg',
    latitude: -26.2023,
    longitude: 28.0436,
    code: 993800
  },
  {
    name: 'Pretoria',
    latitude: -25.7449,
    longitude: 28.1878,
    code: 964137
  },
  {
    name: 'Port Elizabeth',
    latitude: -33.918,
    longitude: 25.5701,
    code: 964420
  },
  {
    name: 'Pietermaritzburg',
    latitude: -29.6168,
    longitude: 30.3928,
    code: 965301
  },
  {
    name: 'East London',
    latitude: -33.0153,
    longitude: 27.9116,
    code: 1006984
  },
  {
    name: 'Bloemfontein',
    latitude: -29.1211,
    longitude: 26.214,
    code: 1018725
  },
  {
    name: 'Klerksdorp',
    latitude: -26.8521,
    longitude: 26.6667,
    code: 989921
  },
  {
    name: 'Kimberley',
    latitude: -28.7323,
    longitude: 24.7623,
    code: 990930
  },
  {
    name: 'Bhisho',
    latitude: -32.8472,
    longitude: 27.4422,
    code: 1019330
  },
  {
    name: 'Polokwane',
    latitude: -23.9045,
    longitude: 29.4688,
    code: 965289
  }
];

export const DaysOfTheWeek = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday'
};

export const SearchRegEx = /^[a-zA-Z0-9\s-]*$/;

export const ErrorKeys = {
  General: 'general',
  Search: 'search',
  Offers: 'offers',
  Technical: 'technical',
  Empty: 'empty',
  TextOnly: 'textonly',
  Children: 'children'
};

export const AdvanceType = {
  Airtime: 'AIRTIME',
  Data: 'DATA',
  Voice: 'VOICE'
};

export const UserTypes = {
  Prepaid: 'PREPAID',
  Hybrid: 'HYBRID',
  Contract: 'CONTRACT'
};

export const BrowserNames = {
  Safari: 'SAFARI',
  Chrome: 'CHROME'
};

export const OtpType = {
  Auth: 'AUTH',
  Otp: 'OTP',
  Bundles: 'BUNDLES'
};

export const JavascriptTypes = {
  Array: 'array',
  Object: 'object',
  String: 'string',
  Function: 'function',
  Number: 'number'
};

export const BundleTypes = {
  Airtime: 'AIRTIME',
  Data: 'DATA',
  SMS: 'SMS',
  Voice: 'VOICE'
};

export const ConfigContexts = {
  ConnectU: 'ConnectU Config',
  VodaPay: 'VodaPay Config'
};

export const OriginContexts = {
  VodaPay: 'vodapay'
};

export const Soid = {
  FaceBookFlex: 'J779'
};

export const AdjustDNS = 'app.adjust.com';
